import { Box, BoxProps, Flex, HStack, Image, useDisclosure } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import {
  BaseNav,
  RouteAuthenticationRequirement,
  useAuth,
  useNavItemStore,
  BaseDialog,
  BaseButton, SupportButton
} from '@cks-internal/react-base';
import { ApplicationRoutes } from '../../constants/appRoutes.ts';
import { useMemo } from 'react';
import logo from '../../assets/logo.svg';
import { ChemRxUser } from '../../globalModels/user/chemRxUser.ts';
import {  faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import { MarkdownViewer } from '../common/MarkdownViewer.tsx';
import pricingGuideContent from '../../features/productAdmin/docs/PRICING_GUIDE.md?raw';

type NarrowLayoutProps = {
  containerProps?: BoxProps;
};

export const NarrowLayout = (props: NarrowLayoutProps) => {
  const routeNav = useNavItemStore((state) => {
    return { items: state.getDefault(), get: state.get };
  });

  const profileItems: BaseNav.NavItem = useMemo(() => {
    const subItems: BaseNav.NavItem[] = [
      routeNav.get(ApplicationRoutes.account.myProfile),
      routeNav.get(ApplicationRoutes.account.logout)
    ];
    return {
      text: 'Profile',
      subItems: subItems,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: []
    };
  }, []);
  const auth = useAuth<ChemRxUser>();
  const pricingGuideDisclosure = useDisclosure();

  return (
    <Box as='section' width='100vw' height='100vh' overflowY='auto'>
      <BaseNav.Header
        avatarName={`${auth.user?.FirstName} ${auth.user?.LastName}`}
        navItems={routeNav.items}
        profileItems={profileItems}
        beforeNavChildren={
          <Flex gap={'6px'} mr='auto'>

            <SupportButton />
            <BaseButton variant='outline' size='sm' onClick={pricingGuideDisclosure.onOpen} icon={faMoneyBill}>
              Pricing Guide
            </BaseButton>
          </Flex>
        }
        logo={
          <HStack>
            <Image height={['65px']} src={logo} alt='logo' />
          </HStack>
        }
      />
      <BaseDialog
        disclosure={pricingGuideDisclosure}
        header='Pricing Guide'
        dragDialog={{ initialW: 900, initialH: 700, minW: 500, minH: 400 }}>
        <Box overflowY='auto' maxH='calc(100% - 60px)' p='4'>
          <MarkdownViewer content={pricingGuideContent} />
        </Box>
      </BaseDialog>
      <Box
        w={['100%', '100%', '100%', '90%']}
        margin={'auto'}
        paddingLeft={'5px'}
        paddingRight={'5px'}
        paddingTop={'10px'}
        {...props.containerProps}>
        <Outlet />
      </Box>
    </Box>
  );
};
